import type { IconSvgObject } from './types';

const ImageDelete01Icon: IconSvgObject = [
  ["path", { d: "M5 21C9.20998 16.2487 13.9412 9.9475 21 14.6734", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21 12.5C21 16.9783 21 19.2175 19.6088 20.6088C18.2175 22 15.9783 22 11.5 22C7.02166 22 4.78249 22 3.39124 20.6088C2 19.2175 2 16.9783 2 12.5C2 8.02166 2 5.78249 3.39124 4.39124C4.78249 3 7.02166 3 11.5 3", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M22 9L18.5 5.5M18.5 5.5L15 2M18.5 5.5L22 2M18.5 5.5L15 9", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "2" }]
];

export default ImageDelete01Icon;
